enum FeedContentType {
  ANNOUNCEMENT = 'announcement',
  CAMPAIGN = 'campaign',
  DONATION = 'donation',
  INTERACTION = 'interaction',
  TASK = 'task',
}

export default FeedContentType;
